import { isAxiosError } from 'axios'

export type AccountConflictErrorBody = {
    code: string
    message: string
    accountId: string
}

const ACCOUNT_CONFLICT_STATUS = 409

/**
 * Extracts the existing account's id from a 409 "user already has an individual
 * account" response. Returns null for any other error shape or status.
 */
export function getAccountConflictId(error: unknown): string | null {
    if (!isAxiosError<AccountConflictErrorBody>(error)) return null
    if (error.response?.status !== ACCOUNT_CONFLICT_STATUS) return null
    return error.response.data?.accountId ?? null
}
